import { Action } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/types/PendingAction';
import { CardOnboardingPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/_shared/entities/PaymentMethodDetail/CardOnboardingPaymentMethodDetailEntity';
import { NextActionPrintCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/NextActions/components/PrintCard/NextActionPrintCard';
import { NextActionValidateCardData } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/CardOnboarding/NextActions/components/ValidateCardData/NextActionValidateCardData';
import { NextActionFactory as LoanNextActionFactory } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/NextActions/components/NextActionFactory';

export interface NextActionFactoryProps {
  action: Action;
  paymentMethodDetailEntity: CardOnboardingPaymentMethodDetailEntity;
  onOpenMerchantPos: () => void;
}

export const NextActionFactory = ({
  action,
  paymentMethodDetailEntity,
  onOpenMerchantPos,
}: NextActionFactoryProps) => {
  if (action === Action.VALIDATE_CARD_DATA) {
    return <NextActionValidateCardData paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  if (action === Action.PRINT_CARD) {
    return <NextActionPrintCard paymentMethodDetailEntity={paymentMethodDetailEntity} />;
  }

  return (
    <LoanNextActionFactory
      action={action}
      paymentMethodDetailEntity={paymentMethodDetailEntity}
      onOpenMerchantPos={onOpenMerchantPos}
    />
  );
};
